import { createContext, useContext } from 'react';

import type { ChatForm as ChatFormValues } from '../../schema/spark/chat-form-schema';
import type { SparkSession } from '../components/Spark/spark-session.types';

export type SparkSessionValue = {
  askAboutDraft: (options: { body: string }) => void;
  editQueuedPrompt: (promptId: string) => void;
  selectChat: (options: { chatId: string | null; isFull?: boolean }) => void;
  session: SparkSession;
  startNewChat: () => void;
  submitPrompt: (values: Partial<ChatFormValues>) => Promise<void>;
};

// Lives here, not beside the provider: `boundaries/element-types` limits what readers may import.
export const SparkSessionContext = createContext<SparkSessionValue | null>(
  null
);

export const useSparkSession = () => {
  const value = useContext(SparkSessionContext);

  if (!value) {
    throw new Error('useSparkSession must be used inside SparkSessionProvider');
  }

  return value;
};
